<script>
    import API from "../services/Api";

    let query = "";
    let waitingRequest = false;
    let clientNotFound = false;
    let requestFailed = false;
    let connectionFailed = false;
    let data = {
        client: {},
        contracts: [],
        invoices: [],
    };

    let pesquisar = async () => {
        clientNotFound = false;
        requestFailed = false;
        connectionFailed = false;
        data = {
            client: {},
            contracts: [],
            invoices: [],
        };

        if ("" === query) {
            alert(
                "Informe um nome de cliente ou CPF/CNPJ para realizar a pesquisa"
            );
            return;
        }

        waitingRequest = true;

        await API.get("clients?query=" + query)
            .then((response) => {
                data.client = response.data.client;
                data.contracts = response.data.contracts;
                data.invoices = response.data.invoices;
                waitingRequest = false;
            })
            .catch((err) => {
                if (err.response) {
                    switch (err.response.status) {
                        case 404:
                            clientNotFound = true;
                            break;
                        case 500:
                            requestFailed = true;
                            break;
                    }
                } else {
                    connectionFailed = true;
                }
                waitingRequest = false;
            });
    };
</script>

<main style="padding: 15px">
    <div class="card">
        <div class="card-body">
            {#if !waitingRequest}
                <div class="input-group mb-3">
                    <input
                        type="text"
                        placeholder="Informe nome ou CPF/CNPJ"
                        bind:value={query}
                        class="form-control" />
                    <div class="input-group-append">
                        <button
                            class="btn btn-outline-secondary"
                            on:click={pesquisar}>
                            Ir
                        </button>
                    </div>
                </div>
            {:else}
                <div class=""><span>Aguarde...</span></div>
            {/if}

            {#if clientNotFound}
                <div class="text-danger text-center">
                    Cliente não encontrado.<br />Verifique as informações e
                    tente novamente!
                </div>
            {/if}

            {#if requestFailed}
                <div class="text-danger text-center">
                    Não foi possível realizar a pesquisa.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

            {#if connectionFailed}
                <div class="text-danger text-center">
                    Houve falha de comunicação com o servidor.<br />
                    Tente novamente em instantes!
                </div>
            {/if}

            {#if data.client.name && !waitingRequest}
                <div class="accordion" id="accordionExample">
                    <div class="card">
                        <div class="card-header" id="headingOne">
                            <h6
                                class="mb-0"
                                data-toggle="collapse"
                                data-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne">
                                #1 Dados cadastrais
                            </h6>
                        </div>
                        <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample">
                            <div class="card-body">
                                <p>Nome: {data.client.name}</p>
                                {#if data.client.CNPJ}
                                    <p>CNPJ: {data.client.CNPJ}</p>
                                    <p>
                                        Nome fantasia:
                                        {data.client.companyName}
                                    </p>
                                {/if}

                                {#if data.client.CPF}
                                    <p>CPF: {data.client.CPF}</p>
                                    <p>RG: {data.client.RG}</p>
                                    <p>
                                        Data de nascimento:
                                        {data.client.bornDate}
                                    </p>
                                    <p>Mãe: {data.client.motherName}</p>
                                {/if}
                                <p>Telefone: {data.client.phone}</p>
                                <p>Celular: {data.client.cellPhone}</p>
                                <p>E-mail: {data.client.email}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header" id="headingTwo">
                            <h6
                                class="mb-0"
                                data-toggle="collapse"
                                data-target="#collapseTwo"
                                aria-expanded="true"
                                aria-controls="collapseTwo">
                                #2 Contratos
                            </h6>
                        </div>
                        <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample">
                            <div class="card-body">
                                <ul class="list-group">
                                    {#each data.contracts as contract, i}
                                        <li class="list-group-item">
                                            <p>
                                                <b>Plano ({i + 1}):
                                                    {contract.plan}</b>
                                            </p>
                                            <p>Status: {contract.status}</p>
                                            <p>
                                                Valor: R$
                                                {contract.amount.toFixed(2)}
                                            </p>
                                        </li>
                                    {/each}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header" id="headingThree">
                            <h6
                                class="mb-0"
                                data-toggle="collapse"
                                data-target="#collapseThree"
                                aria-expanded="true"
                                aria-controls="collapseThree">
                                #3 Faturas
                            </h6>
                        </div>
                        <div
                            id="collapseThree"
                            class="collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample">
                            <div class="card-body">
                                <ul class="list-group">
                                    {#each data.invoices as invoice, i}
                                        <li class="list-group-item">
                                            <p>
                                                <b>Vencimento:
                                                    {invoice.dueDate}</b>
                                            </p>
                                            <p>
                                                Valor: R$
                                                {invoice.amount.toFixed(2)}
                                            </p>
                                        </li>
                                    {/each}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </div>
</main>
